/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantUpdateForListType } from '../../types';

type TenantUpdatesStateType = {
    all: TenantUpdateForListType[],
    fetchingAll: boolean
};

const initialState: TenantUpdatesStateType = {
    all: [],
    fetchingAll: false
};

const slice = createSlice({
    name: 'tenantUpdates',
    initialState,
    reducers: {
        fetchAll: (state) => {
            state.fetchingAll = true;
        },
        allFetched: (state, action: PayloadAction<{ data: TenantUpdateForListType[] }>) => {
            state.all = action.payload.data;
            state.fetchingAll = false;
        }
    }
});

export default slice;
